import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { mapCategoryNodeResponse } from '@core/models/category.mapper';
import { CategoryNodeResponse } from '@core/models/category.response';
import { CategoryNodeState } from '@core/models/category.state';
import { ApiService } from '@core/services/api.service';

import { CategoryRepository } from './category.repository';

@Injectable()
export class CategoryHttpRepository implements CategoryRepository {
  private readonly api = inject(ApiService);

  tree(): Observable<CategoryNodeState[]> {
    return this.api
      .get<CategoryNodeResponse[]>('categories/tree')
      .pipe(map(nodes => nodes.map(mapCategoryNodeResponse)));
  }

  getBySlug(slug: string): Observable<CategoryNodeState | null> {
    return this.api
      .get<CategoryNodeResponse | null>(`categories/by-slug/${slug}`)
      .pipe(map(response => (response ? mapCategoryNodeResponse(response) : null)));
  }
}
